import { isArray } from 'lodash'
import { Feature } from 'ol'
import GeoJSON, { GeoJSONFeature } from 'ol/format/GeoJSON'
import { Geometry } from 'ol/geom'

export function geoJsonFeaturesToFeatures(json: GeoJSONFeature[]): Feature[] {
  const options = {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
  }
  if (isArray(json)) {
    return new GeoJSON().readFeatures(
      {
        type: 'FeatureCollection',
        features: json,
      },
      options,
    )
  } else {
    return [new GeoJSON().readFeature(json, options) as Feature<Geometry>]
  }
}
